import { UserShortWithWork } from "tm-shared/types";

export const filterMembers = (
    members: UserShortWithWork[],
    searchQuery: string,
): UserShortWithWork[] => {
    const normalizedSearch = searchQuery.trim().toLowerCase();

    if (!normalizedSearch) {
        return members;
    }

    return members.filter(
        ({ userInfo }) =>
            userInfo.fullName.toLowerCase().includes(normalizedSearch) ||
            userInfo.phone.includes(normalizedSearch),
    );
};

export const sortMembersByWorkStatus = (
    members: UserShortWithWork[],
): UserShortWithWork[] => {
    return [...members].sort((a, b) => {
        if (a.isWorking && !b.isWorking) return -1;
        if (!a.isWorking && b.isWorking) return 1;
        return 0;
    });
};
